export const dayStartHour = 9
export const hoursPerDay = 10
export const dayEndHour = dayStartHour + hoursPerDay

export const lineHeight = 20
export const allMeetingsHeight = lineHeight * hoursPerDay

export const timeLineRowWidth = 15
export const fontSize = 12


// WEBPACK FOOTER //
// ./src/components/body/line/column/constants.js